<template>
    <div class="language-selector">
        <div v-for="lang in languages" :key="lang.id"
             @click="changeLanguage(lang.code)"
             :class="['language', { 'active': lang.selected, 'has-name': lang.name }]">
            {{ !!lang.name ? lang.name : lang.code }}
        </div>
    </div>
</template>

<script>
    export default {
        name: "Languages",
        props: ["languageList"],
        watch: {
            languageList() {
                this.handleLanguages();
            }
        },
        data() {
            return {
                languages: []
            }
        },
        created() {
            this.handleLanguages();
        },
        methods: {
            handleLanguages() {
                if (!this.languageList) return;

                this.languages = this.languageList;

                this.languages.map((lang, index) => {
                    this.languages[index].selected = index === 0
                });

                this.emitSelectedLanguage();
            },

            changeLanguage(newLangCode) {
                this.languages.map((lang, index) => {
                    this.languages[index].selected = lang.code === newLangCode;
                });

                this.emitSelectedLanguage();
            },

            emitSelectedLanguage() {
                const selectedLangCode = this.languages.filter(lang => lang.selected)[0].code;

                this.$forceUpdate();
                this.$emit('selectedLanguageCode', selectedLangCode)
            },
        }
    }
</script>

<style scoped lang="scss">
    $border-color: rgba($black-1, .1);

    .language-selector {
        display: flex;
        width: max-content;
        margin-bottom: 28px;
        border: 1px solid $border-color;
        border-radius: 4px;

        .language {
            padding: 12px 16px;

            font-size: 14px;
            line-height: 16px;

            border-right: 1px solid $border-color;
            cursor: pointer;

            & div:not(.has-name) {
                text-transform: uppercase;
            }

            &:hover:not(.active) {
                background: $gray-1;
            }

            &:last-of-type {
                border-right: 0;
            }

            &.active {
                cursor: default;
                background: $green;
                color: #fff;

                &:first-of-type {
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                }

                &:last-of-type {
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                }
            }
        }
    }
</style>